import type { NotesState, TreeNode } from "../lib/types";

export type ConnectionStatus =
  | "disconnected"
  | "connecting"
  | "live"
  | "completed"
  | "error";

export function normalizeNotesState(noteData: NotesState): NotesState {
  let tree = noteData.tree;
  if (tree && (tree as unknown as { root: TreeNode }).root) {
    tree = (tree as unknown as { root: TreeNode }).root;
  }

  return {
    contactId: noteData.contactId,
    tree,
    tail: noteData.tail || [],
    status: noteData.status || "live",
    version: noteData.version || 1,
  };
}

export function getConnectionStatusForNotesStatus(
  status: NotesState["status"] | undefined
): ConnectionStatus {
  return status === "completed" ? "completed" : "live";
}

export function recoverConnectionStatusOnStreamOpen(
  currentStatus: ConnectionStatus
): ConnectionStatus {
  return currentStatus === "completed" ? "completed" : "live";
}
